import React, { useState } from "react";
import { MdOutlineKeyboardDoubleArrowRight, MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";

const images = [
    "assets/fgts_carousel/step-1.png",
    "assets/fgts_carousel/step-2.png",
    "assets/fgts_carousel/step-3.png",
    "assets/fgts_carousel/step-4.png",
    "assets/fgts_carousel/step-5.png",
    "assets/fgts_carousel/step-6.png",
    "assets/fgts_carousel/step-7.png",
];

export default function CarouselFGTS() {
    const [current, setCurrent] = useState(0);

    const next = () => {
        setCurrent((prev) => (prev + 1) % images.length);
    };

    const prev = () => {
        setCurrent((prev) => (prev - 1 + images.length) % images.length);
    };

    const getTitle = () => {
        return current === 0 ? "Acesse o app FGTS Caixa" : current === 1 ? "Aderir ao Saque-Aniversário" : current === 2 ? "Modalidade Saque-Aniversário" :
            current === 3 ? "Autorizar consulta FGTS" : current === 4 ? "Termos e condições" : current === 5 ? "Adicionar instituição financeira" : "Autorizar a consulta de dados e pronto!"
    }

    const getDesc = () => {
        return current === 0 ? "Baixe o app FGTS Caixa no seu celular, faça o login com o seu CPF." : current === 1 ? 'Após fazer o login, clique em "Sistemática de saque do seu FGTS"'
            : current === 2 ? 'Escolha a opção "Modalidade Saque-Aniversário", marque os termos e clique em "Optar pelo Saque-Aniversário"'
                : current === 3 ? 'Na tela inicial, clique em "Sistemática de saque do seu FGTS", depois "Empréstimo Saque-aniversário" e então "Autorizar consulta de dados"'
                    : current === 4 ? 'Leia e aceite os termos e condições clicando na chave e depois em "Continuar"'
                        : current === 5 ? 'Clique em "Adicionar instituição +"usque e selecione o "Banco Bmg S.A."'
                            : 'Clique em "Sim" para autorizar a consulta e pronto, você autorizou o Banco Bmg a consultar seu FGTS'
    }

    return (
        <div className="relative w-[250px] mx-auto overflow-hidden rounded-2xl">
            <div className="flex transition-transform duration-500 ease-in-out" style={{ transform: `translateX(-${current * 100}%)` }}>
                {images.map((img, idx) => (
                    <React.Fragment>
                        <img key={idx} src={img} alt={`slide-${idx}`} className="w-full flex-shrink-0 object-cover" />
                    </React.Fragment>
                ))}
            </div>

            <div className="mb-11 p-5 bg-white rounded-lg">
                <h1 className="text-[#462A71]">Passo 0{current + 1} de 0{images.length}</h1>
                <h1>{getTitle()}</h1>
                <p>{getDesc()}</p>
            </div>

            <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex justify-between items-center gap-2">
                <button
                    onClick={prev}
                    className="bg-white/70 hover:bg-white p-2 rounded-full shadow"
                >
                    <MdOutlineKeyboardDoubleArrowLeft color="#03103b" />
                </button>
                {images.map((_, idx) => (
                    <div
                        key={idx}
                        className={`h-2 w-2 rounded-full ${current === idx ? "bg-[#462A71]" : "bg-[#462A71]/50"}`}
                    ></div>
                ))}
                <button
                    onClick={next}
                    className="bg-white/70 hover:bg-white p-2 rounded-full shadow"
                >
                    <MdOutlineKeyboardDoubleArrowRight color="#03103b" />
                </button>
            </div>
        </div>
    );
}
